import styled, { keyframes } from "styled-components";

export const MainContainer = styled.div`
  /* flex: 1; */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  height: 80vh;
  width: 30vw;

  background: var(--bg-primary);
  box-shadow: 0 1px 32px 0 var(--bg-primary);
  backdrop-filter: blur(8.5px);

  color: var(--fore-primary);
  text-transform: uppercase;
  letter-spacing: 0.4rem;
  transition: 0.8s;

  @media only screen and (min-width: 0px) {
    width: 80vw;
    height: 90vh;
    border-radius: 10px;
    hr {
      margin-bottom: 0.3rem;
    }
    h4 {
      font-size: small;
    }
  }
  /* @media only screen and (min-width: 600px) {
    width: 400px;
    height: 90vh;
    border-radius: 40px;
  } */
`;

export const ButtonContainer = styled.div`
  margin: 1rem 0 1rem 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const StyleButton = styled.button`
  background: #070255;
  text-transform: uppercase;
  letter-spacing: 0.2rem;
  width: 65%;
  height: 3rem;
  border: none;
  color: white;
  border-radius: 1rem;
  cursor: pointer;
  transition: 0.5s;
  opacity: 0.9;
  :hover {
    background-color: #50eb0dd8;
    opacity: 1;
  }
`;

export const WelcomeText = styled.h2`
  margin: 1rem 0 2rem 0;
  color: rgb(177, 239, 180);
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  height: 20%;
  width: 100%;
`;

export const LoginWith = styled.h5`
  cursor: pointer;
`;

export const HorizontalRule = styled.hr`
  width: 90%;
  height: 0.3rem;
  border-radius: 0.8rem;
  border: none;
  margin: 1.5em 0 1rem 0;
  background: linear-gradient(to right, #14163c 0%, #03217b 79%);
  backdrop-filter: blur(25px);
`;

export const IconContainer = styled.div`
  display: flex;
  justify-content: space-evenly;
  margin: 1rem 0 1rem 0;
  width: 80%;
`;

export const ForgotPassword = styled.h4`
  cursor: pointer;
`;

const borderAnimKey = keyframes`
  
  0% {background-color: linear-gradient(0deg, #f8edf3, #0d1382) ; opacity:0.3}
  50% {background-color: linear-gradient(90deg, #f8edf3, #0d1382); opacity:0.8}
  100% {border-image: linear-gradient(75deg, #7f7ba7, #0d1382) 1; opacity:0.3}
`;

// export const BackgroudHelper = styled.div`
//   display: "flex";
//   position: fixed;
//   left: 0;
//   top: 50%;
//   background-color: #1751ef7a;
//   width: 100%;
//   min-height: 150vh;
//   border: "none";
//   animation-name: ${borderAnimKey};
//   animation-duration: 20s;
//   animation-iteration-count: infinite;
// `;
